<template>
  <div class="hello flex">
    <div class="left">
      <volLeft></volLeft>
    </div>
    <div class="right" v-if="!$route.query.cache_id">
      <el-table :data="record" stripe border style="width: 100%">
        <el-table-column prop="create_time" label="创建时间">
        </el-table-column>
        <el-table-column prop="batch" label="批次">
        </el-table-column>
        <el-table-column prop="enroll_type" label="科目">
        </el-table-column>
        <el-table-column prop="score" label="分数">
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <span style="color: #19CACA;cursor: pointer;" @click="see(scope.row)">
              查看
            </span>
            <span @click="del(scope.row)" style="cursor: pointer;">
              删除
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="right" v-else>
      <div class="tablehead flex">
        <span style="width:100px;">志愿序号</span> <span style="width:300px;">院校信息</span> <span
          style="width:100px;">志愿代码</span>
        <span style="width:300px;">专业录取信息</span><span style="width:100px;">录取概率</span>
      </div>
      <div class="tablemain">
        <div class="tableone flex" v-for="(item,index) in data">
          <div class="one" style="width:100px;display: flex;
        justify-content: center;
        flex-direction: column;border-right: 1px solid #19caca;">
            院校志愿{{index+1}}
          </div>
          <div class="schoolinfo" style="width:300px;padding: 10px 0px;display: flex;
    align-items: center;
    justify-content: center;font-size: 13px;">
            <div>
              <p>{{item.school_name}}</p>
              <p>院校代码：{{item.enroll_code}}</p>
              <p>{{item.examinee_type}}丨{{item.batch_name}}
              </p>
              <p class="schoolRate">
                <!-- <span>冲</span> -->
                <span class="rate1" v-if="item.check_result=='guarantee'">保</span>
                <span class="rate2" v-if="item.check_result=='safe'">稳</span>
                <span class="rate3" v-if="item.check_result=='danger'">冲</span>
                <span>{{item.rate}}</span>%
              </p>
            </div>
          </div>
          <div class="zhuanye" style="width: 100px;">
            <div class="code" v-for="(item1,index1) in item.major_list">{{item1.major_code}}</div>

          </div>
          <div class="zhuanye flex" style="width: 300px;border-right: 1px solid #19caca;">
            <div class="one flex" style="flex-wrap: wrap;" v-for="(item1,index1) in item.major_list">
              <div style="display: flex;
        justify-content: center;
        flex-direction: column;margin-right: 30px;">专业{{index1+1}}</div>
              <div class="zhuanyeinfo">
                <p>{{item1.major_name}}</p>
              </div>
            </div>
            <div class="" style="text-align: center;margin: 0;" v-if="item.major_list.length==0">
              <el-empty style="padding: 20px 0;" :image-size="100" description='暂未填写专业'></el-empty>
            </div>
          </div>
          <div style=" width: 100px;
          text-align: center;" class="zhuanyeinfo flex">
            <p class="zhuanyeRate" style="margin: 13px 0 19px 20px;text-align: left;font-size: 20px;"
              v-for="(item1,index1) in item.major_list">
              {{item1.rate}}%
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import volLeft from '../../components/volLeft.vue'
  export default {
    data() {
      return {
        data: [],
        record: []
      }
    },
    components: {
      volLeft
    },
    created() {
      if (this.$route.query.cache_id) {
        this.$http.checkResultDetail({
          id: this.$route.query.cache_id
        }).then(res => {
          this.data = res.data.result
        })
      } else {
        this.$http.checkRresultList().then(res => {
          this.record = res.data.list
        })
      }
      this.$nextTick(() => {
        // 禁用右键
        document.oncontextmenu = new Function("event.returnValue=false");
        // 禁用选择
        document.onselectstart = new Function("event.returnValue=false");
      });
    },
    methods: {
      see(item) {
        this.$router.push(`/form?cache_id=${item._id.$oid}`)
      },
      del(item) {
        this.$http.del({
          cache_id: item._id.$oid
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.$http.checkRresultList().then(res => {
              this.record = res.data.list
            })
          }
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .add {
    width: 980px;
    height: 50px;
    line-height: 50px;
    background: #E8FAFA;
    border: 1px solid #19CACA;
    border-radius: 4px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #19CACA;
    text-align: center;
    cursor: pointer;
  }

  .tablehead {
    width: 979px;
    height: 51px;
    background: #FAFAFA;
    line-height: 51px;
  }

  .tip {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin: 12px auto;
  }

  .code {
    color: #19CACA;
    margin-left: 18px;
    line-height: 26px;
  }

  .zhuanyeRate {
    color: #FEBD0C;
    font-size: 24px
  }

  .schoolRate {
    margin-top: 10px;

    .rate1 {
      font-size: 14px;
      color: #19CACA;
    }

    .rate2 {
      font-size: 14px;
      color: #FFBD09;
    }

    .rate3 {
      font-size: 14px;
      color: #F86A4B;
    }

    & span:nth-child(1) {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-color: red;
      border-radius: 5px;
      color: #FFFFFF;
      line-height: 24px;
      margin-right: 7px;
    }

    & span:nth-child(2) {
      font-size: 24px
    }
  }

  .schoolinfo {
    display: flex;
    align-items: center;
    justify-content: center;

    & p:nth-child(1) {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }

    & p:nth-child(2) {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin: 15px 0 18px 0;
      color: #999999;
    }


  }

  .zhuanyeinfo {
    margin: 5px;

  }

  .code {

    margin: 13px 0 14px 20px;

  }

  .zhuanye {
    text-align: left;
    border-left: 1px solid #19caca;

    &>div {
      // height: 80px;
      margin: 13px 0 14px 20px;
    }
  }

  .tablemain {
    width: 979px;
    border-top: 1px solid #19caca;
  }

  .tableone {
    width: 979px;
    border: 1px solid #19caca;
    border-top: none;
    align-items: normal;

    &>div {
      display: inline-block;
    }
  }

  .right {
    width: 900px;
    margin-left: 40px;
  }

  .active {
    font-weight: 400;
    color: #19CACA;
    background: #D1F4F4;
  }

  .hello {
    width: 1280px;
    margin: 20px auto;
    align-items: flex-start;
  }

  .batch {
    image {
      width: 28px !important;
      height: 22px;
    }

    .listone1 {
      margin: 10px 44px;
      border: 1px solid #E6E6E6;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 22px;
      text-align: left;

      text {
        font-size: 16px;
        color: #797373 !important;
        margin-right: 19px;
      }

      image {
        width: 14px;
        height: 25px;
      }

      .left1 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        margin-top: 14px;
      }

      .left2 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        margin: 19px 0 15px 0;
      }

      .left3 {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #19CACA;
      }
    }
  }

  .confirm {
    width: 558px;
    // height: 456px;
    background: #FFFFFF;
    border-radius: 10px;
    z-index: 1000;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -279px;
    margin-top: -228px;

    button {
      width: 100px;
      height: 40px;
      background: #19CACA;
      border-radius: 20px;
      border: none;
      outline: none;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }

    .right_tip {
      position: absolute;
      right: 30px;
      top: 10px;
    }

    .form>div {
      margin-bottom: 34px;
      position: relative;

      span {
        width: 64px;
        height: 15px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }

    .form input {
      width: 387px;
      height: 41px;
      border: 1px solid #E6E6E6;
      border-radius: 20px;
      outline: none;
      margin-left: 38px;
      text-indent: 23px;
    }

    .head {
      margin: 47px 77px 44px 70px;

      span {
        display: inline-block;
        width: 50%;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
      }
    }
  }

  .form {
    padding-bottom: 40px;
  }

  .sure {
    width: 299px !important;
    height: 40px;
    background: #19CACA;
    border-radius: 20px;
    margin-top: 27px;
  }

  .selected {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333 !important;
  }

  .change {
    width: 205px;
    height: 151px;
    background: #FFFFFF;
    border: 1px solid #EDEDED;
    border-radius: 10px;

    p {
      width: 204px;
      height: 50px;
      line-height: 50px;
    }
  }

  .current {
    width: 324px;
    height: 39px;
    line-height: 39px;
    border-radius: 10px;
    margin-bottom: 12px;
    color: #FA6002;

    span {
      display: inline-block;
    }

    .dangqian {
      width: 236px;
    }
  }

  .score {
    width: 176px;
    height: 80px;
    border-radius: 6px;
    background-color: #E8FAFA;
    margin: 18px auto;
    line-height: 25px;
    color: #19CACA
  }

  .line {
    margin: 25px 0 18px 0;
    color: #19CACA
  }

  .info {
    // width: 205px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;

    button {
      width: 177px;
      height: 33px;
      border: 1px solid #19CACA;
      border-radius: 6px;
      background-color: #FFFFFF;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #19CACA;
      margin-top: 15px;
    }

    &>p {
      width: 100%;
      text-align: left;
      margin: 20px 0px 20px 24px;
    }

    .head {
      height: 60px;
      background: #19CACA;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }

  .change {
    width: 205px;
    height: 151px;
    background: #FFFFFF;
    border: 1px solid #EDEDED;
    border-radius: 10px;

    p {
      width: 204px;
      height: 50px;
      line-height: 50px;
    }
  }

  .hello {
    width: 1280px;
    margin: 20px auto;
    align-items: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/volunteer/form.vue